import { SelectOption } from '../types'

export const landType = ['Level Block', 'Sloping Block']

export const landTypeOptions: SelectOption[] = landType.map((landType) => ({
  value: landType,
  label: landType,
}))
